
// src/redux/actions/authActions.js
import axios from "axios";
// // Assuming the API URL is set in your .env file
const BASE_URL = process.env.REACT_APP_API_BASE_URL

export const login = (phone, password) => async (dispatch) => {
  try {
    const response =  await axios.post(`${BASE_URL}/v1/api/admin-login`, {
              phone,
              password,
            });

    if (response.data.meta.status) {
      dispatch({
        type: "LOGIN_SUCCESS",
        payload: response.data.data,
      });
      return response.data;
    } else {
      dispatch({ type: "LOGIN_FAIL" });
      throw new Error(response.data.meta.message);
    }
  } catch (error) {
    dispatch({ type: "LOGIN_FAIL" });
    throw error;
  }
};





export const logout = () => (dispatch) => {
  try {
    // Remove all relevant session data from localStorage
    localStorage.removeItem('token');
    localStorage.removeItem('phone');
    localStorage.removeItem('role');
    localStorage.removeItem('userId');
    
    // Dispatch logout action to Redux store
    dispatch({ type: "LOGOUT" });

  } catch (error) {
    console.error('Error during logout:', error);
  }
};
